import React, { useMemo } from 'react';
import './index.scss';
import RemarkBanner, { RemarkBannerType } from '@/components/RemarkBanner';

export type RemarkItem = {
  // 用于 React key，确保列表渲染稳定
  id: string;
  // 横幅类型：决定展示策略与样式
  type: RemarkBannerType;
  // 文案
  message?: string;
  // 是否展示（最终是否渲染还会结合 message 判定）
  visible?: boolean;
};

type RemarkStackProps = {
  // 按数组顺序从上到下堆叠；上层调用者负责排序（例如：严重告警在上，普通提示在下）
  items: RemarkItem[];
};

/**
 * 多条提示的堆叠容器：只负责「布局/排列/过滤空数据」，不处理文案展示策略
 * @param {*} { items }
 * @return {*}
 */
const RemarkStack: React.FC<RemarkStackProps> = (props) => {
  const { items } = props;

  /**
   * 计算可见的提示项列表
   */
  const visibleItems = useMemo(
    // 过滤掉不可见或空文案项，避免出现空白条
    () => items.filter((item) => Boolean(item.visible && item.message)),
    [items]
  );

  // 没数据直接不渲染
  if (visibleItems.length === 0) return null;

  return (
    <div className="remark-stack">
      {visibleItems.map((item) => (
        <RemarkBanner
          key={item.id}
          type={item.type}
          visible={item.visible}
          message={item.message}
        />
      ))}
    </div>
  );
};

export default React.memo(RemarkStack);
